export const APP_PUBLIC_NAME = {'es': 'Clima', 'en': 'Weather'};